export default (value: string) => `${value} is required`;
